<template>
  <section class="overflow-hidden ">
    <div class="relative mx-auto max-w-7xl px-4 pt-20 pb-12 sm:px-6 lg:px-8 lg:py-20">
      <svg class="absolute top-full left-0 translate-x-80 -translate-y-24 transform lg:hidden" width="784" height="404" fill="none" viewBox="0 0 784 404" aria-hidden="true">
        <defs>
          <pattern id="e56e3f81-d9c1-4b83-a3ba-0d0ac8c32f32" x="0" y="0" width="20" height="20" patternUnits="userSpaceOnUse">
            <rect x="0" y="0" width="4" height="4" class="text-gray-200" fill="currentColor" />
          </pattern>
        </defs>
        <rect width="784" height="404" fill="url(#e56e3f81-d9c1-4b83-a3ba-0d0ac8c32f32)" />
      </svg>

     

      <div class="relative lg:flex lg:items-center">
        <div class="hidden lg:block lg:flex-shrink-0">
          <img class="h-full w-64 rounded-full xl:h-200 xl:w-80" src="@/assets/logo.png" alt="" />
        </div>

        <div class="relative lg:ml-10">
        
          <blockquote class="relative">
          <div class="ml-4 lg:ml-0">
                  <div class="text-base font-medium text-black">QUIENES SOMOS?</div>
                </div>
            <div class="sm:text-xl mt-8 text-right font-medium leading-8 text-black">
              <p>EL CENTRO DE ALTOS ESTUDIOS NACIONALES COCHABAMBA</p>
              <p>(CDAEN - COCHABAMBA) cuya sigla es “CDAEN”, es una asociación de derecho privado, sin fines de lucro, organizado de acuerdo a los preceptos de la Constitución Política del Estado Plurinacional y Leyes vigentes, que asocia y representa a los profesionales Graduados de la Escuela de Altos Estudios Nacionales “CNL. EDUARDO AVAROA” acreditados conforme a lo establecido en el presente Estatuto</p>
            </div>
            <footer class="mt-8">
              <div class="flex">
                <div class="flex-shrink-0 lg:hidden">
                  <img class="h-12 w-12 rounded-full" src="@/assets/logo.png" alt="" />
                </div>
                
              </div>
            </footer>
          </blockquote>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
export default {
    name: 'Home',
    mounted() {
        document.title="Home|";
    },
    data() {
        return {
           
        }
    },
}
</script>